export default {
  prepare(product) {
    product = Core.Array.newObject(product)

    product.verbal = ''

    if (Core.Product.conditionalIsEnabled(product)) {
      if (product.conditionalSeasonId !== '') {
        product.conditionalSeasonId = Core.Value.encode(product.conditionalSeasonId, Core.Value.typeMultiSelect)
      }

      if (product.conditionalLeagueId !== '') {
        product.conditionalLeagueId = Core.Value.encode(product.conditionalLeagueId, Core.Value.typeMultiSelect)
      }

      if (product.conditionalDistrictId !== '') {
        product.conditionalDistrictId = Core.Value.encode(product.conditionalDistrictId, Core.Value.typeMultiSelect)
      }

      product.conditional = {
        eventDateId: null,
        seasonId: null,
        leagueId: null,
        districtId: null
      }

      if (product.conditionalForceDate) {
        if (product.conditionalDateCount !== undefined &&  product.conditionalDateCount !== '' && product.conditionalDateCount > 0) {
          product.conditional.eventDateId = []
          for(let eventDateIndex = 0; eventDateIndex < product.conditionalDateCount; eventDateIndex ++) {
            product.conditional.eventDateId.push({
              id: ''
            })
          }
        } else {
          product.verbal = ''
        }
      }
    }

    if (Core.Product.participantModeIsEnabled(product)) {
      product.participant = {
        firstname: '',
        lastname: '',
        birthdate: '',
        urgencyPhone: '',
        urgencyContact: '',
        teamId: '',
        participantCategoryId: '',
        tshirtSize: '',
        tshirtCustomName: '',
        insuranceNumber: '',
        teamTitle: ''
      }
    }
    return product
  },
  validation(product, productIndex) {
    let isValid = true
    let alertMessage = ''

    if(product.conditional !== undefined && product.conditional.eventDateId !== undefined && Array.isArray(product.conditional.eventDateId)) {
      for(let eventDate in product.conditional.eventDateId) {
        eventDate = product.conditional.eventDateId[eventDate]
        if (!Core.Validation.isId(eventDate.id)) {
          alertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez sélectionner un événement pour le produit {0} #{1}'), product.title, productIndex + 1)
          isValid = false
        }
      }
    }

    if (product.participant !== undefined) {
      if (product.participant.firstname === '') {
        alertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer un prénom pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
        isValid = false
      }
      if (product.participant.lastname === '') {
        alertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer un nom de famille pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
        isValid = false
      }
      if (product.participant.birthdate === '') {
        alertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer une date de naissance pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
        isValid = false
      }
      if (product.participant.insuranceNumber === '') {
        alertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer un numéro d\'assurance maladie pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
      }
      if (product.participant.urgencyContact === '') {
        alertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer un contact d\'urgence pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
        isValid = false
      }
      if (product.participant.urgencyPhone === '') {
        alertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer un numéro d\'urgence pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
        isValid = false
      }
      if (Core.Value.encode(product.teamCreationIsEnabled, 'checkbox')) {
        if (Core.Value.decode(product.participant.teamId, 'select') === 'new' && product.participant.teamTitle === '') {
          alertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez entrer le nom de la nouvelle équipe pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
          isValid = false
        }
      }
      if (Core.Value.encode(product.participantCategoryIsEnabled, 'checkbox')) {
        if (Core.Value.decode(product.participant.participantCategoryId, 'select') === '') {
          alertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez sélectionner une catégorie pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
          isValid = false
        }
      }
      if (Core.Value.encode(product.tshirtSizeIsEnabled, 'checkbox')) {
        if (Core.Value.decode(product.participant.tshirtSize, 'select') === '') {
          alertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez sélectionner une taille pour le participant du produit {0} #{1}'), product.title, productIndex + 1)
          isValid = false
        }
      }
    }
    return {
      isValid: isValid,
      alert: alertMessage
    }
  }
}
